module.exports = __webpack_public_path__ + "static/media/neptune-1.5a996ecd.jpg";